import React, {useRef, useState} from 'react';
import { makeStyles } from '@mui/styles';
import Chip from '@mui/material/Chip';
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import InputAdornment from '@mui/material/InputAdornment';
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import {TextField} from "@mui/material";

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'left',
    flexWrap: 'wrap',
    listStyle: 'none',
    gap: 8,
    padding: theme.spacing(0.5),
    margin: '10px 0 0 0',
  },
  chip: {
    margin: '4px 8px 4px 0',
    cursor: 'grab',
    '&:active': {
      cursor: 'grabbing',
    },
  },
  chipDragging: {
    opacity: 0.4,
  },
  chipOver: {
    borderLeft: '2px solid #1866b8',
  },
  add: {
    margin: '10px 0',
  }
}));
/**
 * Allows you to view and update site array settings.
 * @constructor
 */
export const ArraySettings = ({sites, updateSite, property = 'areas', label="", getChipProps = () => ({})}) => {
  const classes = useStyles();
  let chips = sites[property] || [];
  let textInput = useRef(null);
  const [dragIndex, setDragIndex] = useState(null);
  const [overIndex, setOverIndex] = useState(null);

  const handleChipsUpdate = (chipValues) => {
    const update = {};
    update[property] = chipValues;
    updateSite(update);
    textInput.current.value = "";
  }

  const handleDelete = (chipToDelete) => () => {
    const newChips = chips.filter((chip) => chip !== chipToDelete);
    handleChipsUpdate(newChips);
  };

  const addNew = (value) => {
    if (value) {
      let newChips = chips.filter((chip) => chip !== value);
      handleChipsUpdate([...newChips, value]);
    }
  }

  const keyPress = (e) => {
    if(e.keyCode === 13){
      let value = e.target.value;
      addNew(value);
    }
  };

  const handleDragStart = (index) => (e) => {
    setDragIndex(index);
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragOver = (index) => (e) => {
    e.preventDefault();
    setOverIndex(index);
  };

  const handleDragLeave = () => {
    setOverIndex(null);
  };

  const handleDrop = (dropIndex) => (e) => {
    e.preventDefault();
    if (dragIndex === null || dragIndex === dropIndex) {
      setDragIndex(null);
      setOverIndex(null);
      return;
    }
    const reordered = [...chips];
    const [moved] = reordered.splice(dragIndex, 1);
    reordered.splice(dropIndex, 0, moved);
    setDragIndex(null);
    setOverIndex(null);
    handleChipsUpdate(reordered);
  };

  const handleDragEnd = () => {
    setDragIndex(null);
    setOverIndex(null);
  };

  return (
    <div style={{marginTop:32}}>
      <InputLabel><span style={{textTransform:'capitalize'}}>{label}</span></InputLabel>
      <ul className={classes.root}>
        {chips.map((data, index) => {
          return (
            <li
              key={data}
              draggable
              onDragStart={handleDragStart(index)}
              onDragOver={handleDragOver(index)}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop(index)}
              onDragEnd={handleDragEnd}
              className={`${dragIndex === index ? classes.chipDragging : ''} ${overIndex === index && dragIndex !== index ? classes.chipOver : ''}`}
            >
              <Chip
                {...getChipProps(data)}
                icon={<DragIndicatorIcon fontSize="small" />}
                label={data}
                onDelete={handleDelete(data)}
                className={classes.chip}
              />
            </li>
          );
        })}
      </ul>
        <div className={classes.add}>
          <FormControl className={classes.margin}>
            <TextField
              variant="outlined"
              size={'small'}
              label={'Add New'}
              inputRef={textInput}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start" style={{cursor: 'pointer'}}>
                    <AddCircleOutlineIcon onClick={(e) => {
                      addNew(textInput.current.value);
                    }}/>
                  </InputAdornment>
                ),
              }}
              onKeyDown={keyPress}
            />
          </FormControl>
        </div>
  </div>
  )
}
